import { LINK_FGTS_APP_ANDROID, LINK_FGTS_APP_IOS, LINK_FGTS_WEB } from "../../constants";

export const useOpenFGTSApp = (): void => {
	const userAgent = navigator.userAgent;

	if ((/android/i.test(userAgent))) {
		return void window.open(LINK_FGTS_APP_ANDROID, "_blank");
	}

	if (/iPad|iPhone|iPod/.test(userAgent)) {
		return void window.open(LINK_FGTS_APP_IOS, "_blank");
	}

	return void window.open(LINK_FGTS_WEB, "_blank");
};
